import { sendGet } from './axios';

export const getListEnvTopNavWeb = () => sendGet(`/env-top-navi-webs`);

